import { useNavigate, useParams } from 'react-router-dom';

import type { AssetQualityTabValue } from './useAssetQualityFilterStore';

type UseAssetQualityTabNavigationResult = {
  selectedTabValue: AssetQualityTabValue;
  handleTabChange: (value: AssetQualityTabValue) => void;
};

export const useAssetQualityTabNavigation = (): UseAssetQualityTabNavigationResult => {
  const { tab } = useParams<{ tab?: AssetQualityTabValue }>();
  const navigate = useNavigate();

  const selectedTabValue: AssetQualityTabValue = tab === 'column' ? 'column' : 'table';

  const handleTabChange = (value: AssetQualityTabValue) => {
    navigate(`/quality/${value}`, { replace: true });
  };

  return {
    selectedTabValue,
    handleTabChange,
  };
};
